(function () {
  if (window.innerWidth > 960) return;

  function fixAccordions() {
    var productTop = document.querySelector('.product__top');
    var bottomSection = document.querySelector('.product__bottom-below');

    if (!productTop || !bottomSection) return false;

    // Cacher les doublons dans product__bottom-below
    var dupes = bottomSection.querySelectorAll('.widgets-accordion');
    if (!dupes.length) return false;

    dupes.forEach(function (w) {
      w.style.setProperty('display', 'none', 'important');
    });

    // Afficher les bons dans product__top
    var originals = productTop.querySelectorAll('.widgets-accordion');
    originals.forEach(function (w) {
      w.style.setProperty('display', 'block', 'important');
    });

    return true;
  }

  if (fixAccordions()) return;

  var observer = new MutationObserver(function () {
    if (fixAccordions()) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { observer.disconnect(); }, 10000);
})();
